// extracted by mini-css-extract-plugin
module.exports = {"container":"Item_container__N06Ep","heading":"Item_heading__mhigb","child":"Item_child__NYzjE","image":"Item_image__NiqQm","link":"Item_link__TZ16d"};